export default "__VITE_ASSET__cdfbe07f__"